<template>
    <div class="flex flex-col min-h-screen">
        <!-- Primary Navigation Menu -->
        <Header :title="title" />
        <MainContain>
            <!-- Your page content here -->
            <slot></slot>
            <Footer />
        </MainContain>
    </div>
</template>

<script setup>
import { Link, router } from "@inertiajs/vue3";
import MainContain from "../Components/Layout/MainContain.vue";
import Header from "../Components/Layout/Header.vue";
import Footer from "../Components/Layout/Footer.vue";
import { route } from "ziggy-js";

defineProps({
    title: String,
});

// Function to log out the user
const logout = () => {
    router.post(route("logout"));
};
</script>
